<template>
  <div />
</template>

<script>
export default {
  name: 'NetworkService',
};
</script>
